{
  "metadata": {
    "id": "rosepine-dark",
    "name": "Rose Pine",
    "description": "Портировано из темы «Rose Pine» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "rosepine.json",
      "project": "rose-pine",
      "url": "https://github.com/rose-pine/rose-pine-theme",
      "upstreamFile": "packages/ui/src/theme/themes/rosepine.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 22.4,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.412,
      "paletteMaxS": 0.483,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.0,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 23.9,
      "syntaxVsTextMinDeltaE": 21.3,
      "chartsMinDeltaE": 27.9,
      "textSeparationDeltaE": 24.8,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "comment",
          "b": "operator",
          "deltaE": 13.4
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#9ccfd8",
      "hover": "#a8d5dd",
      "active": "#b0d9e0",
      "foreground": "#000000",
      "muted": "#9ccfd880",
      "emphasis": "#9ccfd8"
    },
    "surface": {
      "background": "#191724",
      "foreground": "#e0def4",
      "muted": "#2c2a39",
      "mutedForeground": "#9d9aaf",
      "elevated": "#353341",
      "elevatedForeground": "#e0def4",
      "raised": "#4d4c5c",
      "raisedForeground": "#e0def4",
      "overlay": "#191724cc",
      "subtle": "#24222f"
    },
    "interactive": {
      "border": "#504e5e",
      "borderHover": "#514f5e",
      "borderFocus": "#9ccfd8",
      "selection": "#e0def429",
      "selectionForeground": "#e0def4",
      "focus": "#9ccfd859",
      "focusRing": "#9ccfd861",
      "cursor": "#e0def4",
      "hover": "#e0def41c",
      "active": "#e0def429"
    },
    "status": {
      "error": "#eb6f92",
      "errorForeground": "#000000",
      "errorBackground": "#eb6f9224",
      "errorBorder": "#eb6f9273",
      "warning": "#f6c177",
      "warningForeground": "#000000",
      "warningBackground": "#f6c17724",
      "warningBorder": "#f6c17773",
      "success": "#3a8aaa",
      "successForeground": "#000000",
      "successBackground": "#3a8aaa24",
      "successBorder": "#3a8aaa73",
      "info": "#9ccfd8",
      "infoForeground": "#000000",
      "infoBackground": "#9ccfd824",
      "infoBorder": "#9ccfd873"
    },
    "pr": {
      "open": "#3a8aaa",
      "draft": "#a7a4b7",
      "blocked": "#f6c177",
      "merged": "#ebbcba",
      "closed": "#eb6f92"
    },
    "syntax": {
      "base": {
        "background": "#3c3a4a",
        "foreground": "#e0def4",
        "comment": "#a7a4b7",
        "keyword": "#2bb6ee",
        "string": "#f6c177",
        "number": "#c4a7e7",
        "function": "#ebbcba",
        "variable": "#e0def4",
        "type": "#9ccfd8",
        "operator": "#a7a3bb"
      },
      "tokens": {
        "commentDoc": "#a7a4b7",
        "stringEscape": "#a7a3bb",
        "keywordImport": "#2bb6ee",
        "storageModifier": "#2bb6ee",
        "functionCall": "#ebbcba",
        "method": "#ebbcba",
        "variableProperty": "#ebbcba",
        "variableOther": "#e0def4",
        "variableGlobal": "#c4a7e7",
        "variableLocal": "#a7a3bb",
        "parameter": "#e0def4",
        "constant": "#c4a7e7",
        "class": "#9ccfd8",
        "className": "#9ccfd8",
        "interface": "#9ccfd8",
        "struct": "#9ccfd8",
        "enum": "#9ccfd8",
        "typeParameter": "#9ccfd8",
        "namespace": "#9ccfd8",
        "module": "#2bb6ee",
        "tag": "#2bb6ee",
        "jsxTag": "#2bb6ee",
        "tagAttribute": "#ebbcba",
        "tagAttributeValue": "#f6c177",
        "boolean": "#c4a7e7",
        "decorator": "#2bb6ee",
        "label": "#ebbcba",
        "regexp": "#f6c177"
      }
    },
    "charts": {
      "series": [
        "#9ccfd8",
        "#6fa7dc",
        "#3a65aa",
        "#f6c177",
        "#eb6f92"
      ]
    },
    "chat": {
      "background": "#191724",
      "userMessage": "#e0def4",
      "userMessageBackground": "#353341",
      "assistantMessage": "#e0def4",
      "assistantMessageBackground": "#2c2a39",
      "timestamp": "#a7a4b7",
      "divider": "#504e5e",
      "typing": "#a7a4b7"
    },
    "loading": {
      "spinner": "#9ccfd8",
      "spinnerTrack": "#2c2a39",
      "skeleton": "#2c2a39",
      "shimmer": "#464454"
    },
    "tools": {
      "background": "#2c2a39",
      "border": "#504e5e",
      "headerHover": "#444252",
      "icon": "#9ccfd8",
      "title": "#e0def4",
      "description": "#a7a4b7",
      "edit": {
        "added": "#3a8aaa",
        "addedBackground": "#3a8aaa24",
        "removed": "#eb6f92",
        "removedBackground": "#eb6f9224",
        "modified": "#9ccfd8",
        "modifiedBackground": "#9ccfd824",
        "lineNumber": "#a7a4b7"
      }
    },
    "markdown": {
      "heading1": "#e0def4",
      "heading2": "#e0def4",
      "heading3": "#e0def4",
      "heading4": "#e0def4",
      "link": "#9ccfd8",
      "linkHover": "#a8d5dd",
      "inlineCode": "#f6c177",
      "inlineCodeBackground": "#2c2a39",
      "blockquote": "#a7a4b7",
      "blockquoteBorder": "#504e5e",
      "listMarker": "#9ccfd8bf",
      "bold": "#e0def4",
      "italic": "#e0def4e6",
      "strikethrough": "#a7a4b7",
      "hr": "#504e5e"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#c2665b",
        "foreground": "#000000",
        "contrast": 5.35
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#d8b3aa",
        "foreground": "#000000",
        "contrast": 10.95
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c59461",
        "foreground": "#000000",
        "contrast": 7.78
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#c2ca69",
        "foreground": "#000000",
        "contrast": 11.95
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#b6c994",
        "foreground": "#000000",
        "contrast": 11.77
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#7ac865",
        "foreground": "#000000",
        "contrast": 10.28
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#6dbc8b",
        "foreground": "#000000",
        "contrast": 9.22
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#a9e1cd",
        "foreground": "#000000",
        "contrast": 14.34
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#66bbc6",
        "foreground": "#000000",
        "contrast": 9.49
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#5e95c2",
        "foreground": "#000000",
        "contrast": 6.55
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#aebdd4",
        "foreground": "#000000",
        "contrast": 11.03
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#5858bd",
        "foreground": "#ffffff",
        "contrast": 5.92
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#8c69af",
        "foreground": "#000000",
        "contrast": 4.75
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#d9a5dd",
        "foreground": "#000000",
        "contrast": 10.38
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#c25eb0",
        "foreground": "#000000",
        "contrast": 5.52
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#b16a85",
        "foreground": "#000000",
        "contrast": 5.27
      }
    ]
  }
}
